/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ggProduct from 'ggApp/modules/product';
import CampaignBadge from 'ggApp/shared/components/campaignBadge';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

const SpecialOffer = ({ campaigns }) => {
    const campaignDescription = campaigns.length
        ? campaigns[0].description
        : null;

    if (!campaignDescription) {
        return null;
    }

    return (
        <CampaignBadge
            title={<Translator tk="CAMPAIGN_PROMO_LABEL" />}
            description={campaignDescription}
        />
    );
};

SpecialOffer.propTypes = {
    campaigns: PropTypes.arrayOf(
        PropTypes.shape({
            description: PropTypes.string,
        }),
    ).isRequired,
};

export default connect(
    createStructuredSelector({
        campaigns: ggProduct.selectors.campaigns,
    }),
)(SpecialOffer);
